module.exports = __webpack_public_path__ + "static/media/Gilroy-Regular.31dc5269.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/gilroy/Gilroy-Regular.woff
// module id = 376
// module chunks = 0